import React from 'react'
import { Spinner } from 'react-bootstrap';
import InfiniteScroll from "react-infinite-scroll-component";

export default function InfiniteScroller({children, dataLength, nextFunc,cssClassName, isLoading}) {
  return (
    <InfiniteScroll
        dataLength={dataLength}
        next={nextFunc}
        hasMore={true}
        className={cssClassName}
        loader={isLoading && <div style={{ display: "flex", justifyContent: "center" }}><Spinner size='sm' animation='grow' aria-hidden="true" style={{ color: "var(--darker_color_shade)", marginTop: "12px" }}></Spinner></div>}
    >
        <div className={cssClassName}>
        {children}
        </div>
    </InfiniteScroll>
  )
}